<template>
  <div class="forex-page">
    <!-- <PreloaderPage /> -->
    <BannerPages
      :title="'forex.titleBanner'"
      :descriptions="[
        $t('forex.descriptionBanner1'),
        $t('forex.descriptionBanner2')
      ]"
      :img="'/images/forex/forex-banner.png'"
      mainImageWidthDesk="579"
      mainImageHeightDesk="498"
      alt="Forex portfolio on phone screen"
      :buttons="[
        {
          type: 'external',
          href: getExternalUrl('/register/1/live-account'),
          class: 'primary-button-medium',
          text: 'home.banner.button-1' 
        },
        {
          type: 'external',
          href: getExternalUrl('/register/1/demo-account'),
          class: 'second-button-medium-white',
          text: 'home.banner.button-2' 
        }
      ]"
    />

    <div class="margin-general forex_tradeview" :style="degrade">
      <div class="forex_tradeview_text">
        <h2>{{ $t("forex.title_forex_tradeview") }}</h2>
        <p class="body-4">{{ $t("forex.description_forex_tradeview") }}</p>
        <p class="body-4 bold">
          {{ $t("forex.description_forex_tradeview2") }}
        </p>
      </div>
      <LazyAccordeon :options="cards" />
    </div>

    <div class="margin-general find_forex">
      <div class="text">
        <h2>{{ $t("forex.find_forex_title") }}</h2>
        <p class="body-4 desc1">{{ $t("forex.find_forex_desc1") }}</p>
        <p class="body-4 bold desc2">{{ $t("forex.find_forex_desc2") }}</p>
      </div>
      <LazyTabsPlatforms :tabs="tabs" :categories="categories" />
    </div>

    <LazyPlatformSlider
      titleSection="forex.choosePlatformTitle"
      descriptionSection="forex.choosePlatformDesc"
      :slider="slider"
      :cardsPlatform="cardsPlatform"
      :slidesPerView="1"
      :spaceBetween="20"
      className="slideX3"
    />

    <div class="margin-general path_market" :style="degrade2">
      <div class="text">
        <h2>{{ $t("forex.path_market") }}</h2>
        <p class="body-4">{{ $t("forex.path_market_desc") }}</p>
      </div>
      <LazyCardsPath :cards="cardsOptions" class="cardsOptions" />
      <p class="body-4 path_check">
        {{ $t("forex.path_check") }}
        <NuxtLink :to="localPath('/trading/accounts')">{{ $t("forex.trading_accounts") }}</NuxtLink>
      </p>
      <div class="buttons">
        <client-only>
          <a target="_blank" :href="getExternalUrl('/register/1/live-account')" class="primary-button-medium"
             rel="noopener noreferrer">
            {{ $t("accounts.tabsAccounts.futures.cards.btn") }}
            </a
          >
        </client-only>
      </div>
    </div>

    <!-- <LazyFeatureBanner
      imgUrl="/images/forex/ILC-Component-forex-img.png"
      width="552"
      height="460"
      :title="featureBannerTitle"
      :subtitle="featureBannerSubtitle"
      :cards="featureBannerCards"
    /> -->

    <LazyMoreResource
      :titleH2="'forms_and_documents.protectedTitle'"
      :cards="cardsSlideProtected"
      :padding="'padding-icon'"
      class="protected with-icons"
    />

    <LazySliderIcons
      :title="'forex.trading_conditions'"
      :description="'forex.trading_conditions_desc'"
      :cards="cardsTradingCond"
    />

    <client-only>
      <LazyInvestment
        :label="'forex.ready'"
        :buttonConfigs="[
          {
            type: 'external',
            href: getExternalUrl('/register/1/live-account'),
            class: 'primary-button-medium',
            textKey: 'market.btn-invest'
          }
        ]"
      />
    </client-only>
  </div>
</template>

<script setup>
import LazyInvestment from "~/components/Investment";
import LazyAccordeon from "~/components/Accordeon";
import LazyTabsPlatforms from "~/components/forex/TabsPlatforms";
import LazyPlatformSlider from "~/components/forex/PlatformsSlider.vue";
import LazyCardsPath from "~/components/CardsPath";
import LazyFeatureBanner from '~/components/FeatureBanner.vue';
import LazyMoreResource from "~/components/home/MoreResource";
import LazySliderIcons from "~/components/SliderIcons";
// import PreloaderPage from "~/components/PreloaderPage.vue";
import { useI18n } from "vue-i18n";
import { useExternalUrl } from '@/composables/useExternalUrl';
import { useImage } from '#imports'; 
// import '~/assets/scss/pages/forex.scss';

const { t, locale } = useI18n();
const { getExternalUrl } = useExternalUrl();
const { $regulationsVar } = useNuxtApp();

const regulation = ref($regulationsVar.getRegulation(locale.value));
const localPath = useLocalePath();
const nuxtImg = useImage();

const title = t("seo.forex.title");
const description = t("seo.forex.description");
const imgSeo = 'https://tradeview.eu/images/seo/17Forex.jpg'

useSeoMeta({
  title: title,
  ogTitle: title,
  twitterTitle: title,
  description: description,
  ogDescription: description,
  twitterDescription: description,
  ogImage: imgSeo,
  twitterImage: imgSeo
});

const degradadeImageUrl = '/images/forex/Forex-Gradient-1.avif';
const degradade2ImageUrl = '/images/forex/Forex-Gradient-2.avif';

const optimizedDegrade = nuxtImg(degradadeImageUrl, {
  quality: 50,
  format: 'avif',
});
const optimizedDegrade2 = nuxtImg(degradade2ImageUrl , {
  quality: 50,
  format: 'avif',
});

const degrade = computed(() => {
  return {
    '--degrade': `url('${optimizedDegrade}')`,
  };
});

const degrade2 = computed(() => {
  return {
    '--degrade2': `url('${optimizedDegrade2}')`,
  };
});

let cards = ref([
  {
    title: "forex.accordeonTitle1",
    text: "forex.accordeonDesc1",
    texts: [
      'forex.accordeonDesc1',
    ],
    icon: "attach_money",
  },
  {
    title: "forex.accordeonTitle3",
    texts: [
      'forex.accordeonDesc3',
    ],
    icon: "devices",
  },
  {
    title: "forex.accordeonTitle4",
    texts: [
      'forex.accordeonDesc4',
    ],
    icon: "account_balance",
  },
  {
    title: "forex.accordeonTitle5",
    texts: [
      'forex.accordeonDesc5',
    ],
    icon: "acute",
  },
  {
    title: "forex.accordeonTitle6",
    texts: [
      'forex.accordeonDesc6',
    ],
    icon: "calendar_clock",
  },
  {
    title: "forex.accordeonTitle7",
    texts: [
      'forex.accordeonDesc7',
    ],
    icon: "output_circle",
  },
]);

let tabs = ref([
  { value: "cfds", label: "forex.CFDs" },
  { value: "indices", label: "forex.Indices" },
  { value: "crypto", label: "forex.Crypto" },
]);

let categories = ref({
  cfds: [
    {
      title: "forex.cfdsTitle",
      description: "forex.cfdsDesc",
      text: {
        title: "forex.cfdsTitleText",
        desc: "forex.cfdsDescText",
      },
      details: [
        {
          icon: "decimal_decrease",
          title: "forex.cfdsDetailsTitle1",
          description: "forex.cfdsDetailsDesc1",
        },
        {
          icon: "stacks",
          title: "forex.cfdsDetailsTitle2",
          description: "forex.cfdsDetailsDesc2",
        },
        {
          icon: "devices",
          title: "forex.cfdsDetailsTitle3",
          description: "forex.cfdsDetailsDesc3",
        },
        {
          icon: "schedule",
          title: "forex.cfdsDetailsTitle4",
          description: "forex.cfdsDetailsDesc4",
        },
      ],
    },
  ],
  indices: [
    {
      title: "forex.indicesTitle",
      description: "forex.indicesDesc",
      text: {
        title: "forex.indicesTitleText",
        desc: "forex.indicesDescText",
      },
      details: [
        {
          icon: "stacks",
          title: "forex.indicesDetailsTitle1",
          description: "forex.indicesDetailsDesc1",
        },
        {
          icon: "finance_mode",
          title: "forex.indicesDetailsTitle3",
          description: "forex.indicesDetailsDesc3",
        },
        {
          icon: "decimal_decrease",
          title: "forex.indicesDetailsTitle4",
          description: "forex.indicesDetailsDesc4",
        },
      ],
    },
  ],
  crypto: [
    {
      title: "forex.cryptoTitle",
      description: "forex.cryptoDesc",
      text: {
        title: "forex.cryptoTitleText",
        desc: "forex.cryptoDescText",
      },
      details: [
        {
          icon: "currency_bitcoin",
          title: "forex.cryptoDetailsTitle1",
          description: "forex.cryptoDetailsDesc1",
        },
        {
          icon: "finance_mode",
          title: "forex.cryptoDetailsTitle3",
          description: "forex.cryptoDetailsDesc3",
        },
        {
          icon: "balance",
          title: "forex.cryptoDetailsTitle4",
          description: "forex.cryptoDetailsDesc4",
        },
      ],
    },
  ],
});

let cardsPlatform = ref([
  /* {
    name: "forex.mt4",
  }, */
  {
    name: "forex.mt5",
  },
 /*  {
    name: "forex.ctrader",
  }, */
]);

let slider = ref([
  /* {
    imgBackground: "/images/forex/backgound-mt4.png",
    imgWidth: 366, 
    imgHeight: 500,
    title: "forex.mt4",
    description: [
      "forex.metatrader4Desc1",
      "forex.metatrader4Desc2",
      "forex.metatrader4Desc3",
      "forex.metatrader4Desc4",
      "forex.metatrader4Desc5",
    ],
    icon: "/images/forex/MT4-Icon.svg",
    alt: "Screen showing Forex Charts",
  }, */
  {
    imgBackground: "/images/forex/background-mt5.png",
    title: "forex.mt5",
    imgWidth: 366, 
    imgHeight: 500,
    description: [
      "forex.metatrader5Desc1",
      "forex.metatrader5Desc2",
      "forex.metatrader5Desc3",
      "forex.metatrader5Desc4",
      "forex.metatrader5Desc5",
    ],
    icon: "/images/forex/MT5-Icon.svg",
    alt: "Technical analysis of currency prices",
  },
 /*  {
    imgBackground: "/images/forex/background-ctrader.png",
    imgWidth: 366, 
    imgHeight: 500,
    title: "forex.ctrader",
    description: [
      "forex.ctraderDesc1",
      "forex.ctraderDesc2",
      "forex.ctraderDesc3",
      "forex.ctraderDesc4",
      "forex.ctraderDesc5",
    ],
    icon: "/images/forex/cTrader-Icon.svg",
    alt: "Live market movements displayed",
  }, */
]);

let cardsOptions = ref([
  {
    title: "accounts.tabsAccounts.forex.cards.card-1-Title",
    options: [
      "accounts.tabsAccounts.forex.cards.card-1-item1",
      "accounts.tabsAccounts.forex.cards.card-1-item2",
      "accounts.tabsAccounts.forex.cards.card-1-item3",
      "accounts.tabsAccounts.forex.cards.card-1-item4",
      /* "accounts.tabsAccounts.forex.cards.card-1-item5", */
    ],
  },
  {
    title: "accounts.tabsAccounts.forex.cards.card-2-Title",
    options: [
     /*  "accounts.tabsAccounts.forex.cards.card-2-item1", */
      "accounts.tabsAccounts.forex.cards.card-2-item2",
      "accounts.tabsAccounts.forex.cards.card-2-item3",
      "accounts.tabsAccounts.forex.cards.card-2-item4",
      /* "accounts.tabsAccounts.forex.cards.card-2-item5", */
    ],
  },
  /* {
    title: "accounts.tabsAccounts.forex.cards.card-3-Title",
    options: [
      "accounts.tabsAccounts.forex.cards.card-3-item1",
      "accounts.tabsAccounts.forex.cards.card-3-item2",
      "accounts.tabsAccounts.forex.cards.card-3-item3",
      "accounts.tabsAccounts.forex.cards.card-3-item4",
      "accounts.tabsAccounts.forex.cards.card-3-item5",
    ],
  }, */
]);

let cardsSlideProtected = ref([
  {
    icon: "sync",
    title: "forms_and_documents.protectedCardTitle1-1",
    desc: "forms_and_documents.protectedCardDesc1-1",
  },
  {
    icon: "account_balance_wallet",
    title: "forms_and_documents.protectedCardTitle2",
    desc: "forms_and_documents.protectedCardDesc2",
  },
  {
    icon: "lock",
    title: "forms_and_documents.protectedCardTitle3",
    desc: "forms_and_documents.protectedCardDesc3",
  },
  {
    icon: "acute",
    title: "forms_and_documents.protectedCardTitle4",
    desc: "forms_and_documents.protectedCardDesc4",
  },
]);

let cardsTradingCond = ref([
  {
    icon: "contract",
    title: "forex.trading_cond_title1",
    description: "forex.trading_cond_desc1",
    link: "forex.trading_cond_link1",
    url: "/trading/markets/trading-conditions/forex-contract-specs",
  },
  {
    icon: "event",
    title: "forex.trading_cond_title2",
    description: "forex.trading_cond_desc2",
    link: "forex.trading_cond_link2",
    url: "/trading/markets/trading-conditions/forex-economic-calendar",
  },
  {
    icon: "article",
    title: "forex.trading_cond_title3",
    description: "forex.trading_cond_desc3",
    link: "forex.trading_cond_link3",
    url: "/trading/markets/trading-conditions/order-types",
  },
  {
    icon: "alarm",
    title: "forex.trading_cond_title4",
    description: "forex.trading_cond_desc4",
    link: "forex.trading_cond_link4",
    url: "/trading/markets/trading-conditions/trading-conditions-events/",
  },
  {
    icon: "cached",
    title: "forex.trading_cond_title5",
    description: "forex.trading_cond_desc5",
    link: "forex.trading_cond_link5",
    url: "/trading/markets/trading-conditions/forex-rollover-rates",
  },
]);

/* const featureBannerTitle = t('forex.featureBanner.title');
const featureBannerSubtitle = 'forex.featureBanner.subtitle';
const featureBannerCards = [
  {
    icon: "compare_arrows",
    title: "forex.featureBanner.card1.title",
    text: "forex.featureBanner.card1.text"
  },
  {
    icon: "assured_workload",
    title: "forex.featureBanner.card2.title",
    text: "forex.featureBanner.card2.text"
  },
  {
    icon: "conversion_path",
    title: "forex.featureBanner.card3.title",
    text: "forex.featureBanner.card3.text"
  },
  {
    icon: "acute",
    title: "forex.featureBanner.card4.title",
    text: "forex.featureBanner.card4.text"
  },
  {
    icon: "trending_up",
    title: "forex.featureBanner.card5.title",
    text: "forex.featureBanner.card5.text"
  },
  {
    icon: "approval_delegation",
    title: "forex.featureBanner.card6.title",
    text: "forex.featureBanner.card6.text"
  }
]; */
</script>